import {defineStore} from 'pinia';
import {ModulePostMulti} from '@/stores/moduleConst';

const action = {
  setMessage(message) {
    this.total = message.Total;
    this.countItems = message.CountItems;
    this.processId = message.ProcessID;
  },
  endMessage() {},
};
export const usePostedMulti = defineStore(ModulePostMulti, {
  state: () => ({
    total: 0,
    countItems: 0,
    processId: null,
  }),
  actions: action,
});
